// extracted by mini-css-extract-plugin
export default {"Container":"Federal_Container__V2dho","section-1":"Federal_section-1__G0IC7","content":"Federal_content__3BrjW","ul":"Federal_ul__BGQdN","section-2":"Federal_section-2__UTZQB"};